<form [formGroup]="tecnicoResponsableFormGroup">
  <div class="row">
    <h4 class="second-header">Datos del Técnico/a Responsable</h4>
  </div>
  <div class="row">
    <mat-form-field class="col-xs-12">
      <input matInput placeholder="Número de afiliado de la Caja de Jubilaciones y Pensiones de Profesionales Universitarios (CJPPU): *"
        formControlName="cjppu" required>
      <mat-error *ngIf="tecnicoResponsableFormGroup.get('cjppu')?.hasError('required')">Número de afiliado de la Caja de Jubilaciones y Pensiones de Profesionales Universitarios (CJPPU) *</mat-error>
    </mat-form-field>
  </div>

  <div class="row">
    <rpe-tecnico-form [formInput]="tecnicoFormInput">
    </rpe-tecnico-form>
  </div>

</form>
